import { Fields, FormState } from "seneca-common/utils/form/types";

export function normaliseFormsData({
  formsData,
  enrichment,
  deletions
}: {
  formsData: FormState["data"];
  enrichment?: Fields;
  deletions?: string[];
}) {
  const flattenFormsData: any = Object.keys(formsData).reduce((acc, key) => {
    const localFormData = { ...formsData[key] };
    deletions?.forEach(item => delete localFormData[item]);
    return { ...acc, ...localFormData };
  }, {});

  return { ...flattenFormsData, ...enrichment };
}

export function getSafe(fn: () => void, defaultVal: any = "") {
  try {
    return fn();
  } catch (e) {
    return defaultVal;
  }
}
